import { createAsyncThunk } from '@reduxjs/toolkit';
import { INotificationSettingsSchema, IUser } from 'bg-server/src/components/api/v1/user/types';
import Translator from 'i18n-babel';

import { settingsService } from 'src/services/settings';
import { updateLangSvc } from 'src/services/user';

import { setLoadingStatus } from '../app';
import { ICoreState } from '../types';

export const updateSettings = createAsyncThunk<IUser, INotificationSettingsSchema, { state: ICoreState }>('settings/update', async (data, thunkAPI) => {
    const { getState, dispatch } = thunkAPI;
    try {
        const { isLoggedIn } = getState().user;
        if (!isLoggedIn) {
            return null;
        }

        const user = await settingsService.updateSetting(data);
        return user;
    } catch (error) {
        dispatch(setLoadingStatus(error.message ? error.message : error));
        throw error;
    }
});

export const updateLang = createAsyncThunk<IUser, string, { state: ICoreState }>('settings/updateLang', async (lang, thunkAPI) => {
    const { getState, dispatch } = thunkAPI;
    try {
        const { isLoggedIn } = getState().user;
        if (!isLoggedIn) {
            return null;
        }
        dispatch(setLoadingStatus(true));
        const user = await updateLangSvc(lang);
        Translator.setLanguage(lang);
        dispatch(setLoadingStatus(false));
        // eslint-disable-next-line no-restricted-globals
        const loc: any = location;
        loc.reload(true);
        return user;
    } catch (error) {
        dispatch(setLoadingStatus(error.message ? error.message : error));
        throw error;
    }
});
